import { render, staticRenderFns } from "./CompanyColorsInput.vue?vue&type=template&id=710df678&lang=pug&"
import script from "./CompanyColorsInput.vue?vue&type=script&lang=ts&"
export * from "./CompanyColorsInput.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyColorsInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports